var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-item"},[(_vm.list.length)?_c('div',_vm._l((_vm.list),function(item){return _c('HeadItem',{key:item.id,staticStyle:{"margin-top":"8px"},attrs:{"mes":item}})}),1):_c('div',{staticClass:"f11"},[_vm._v("\n    暂时还没有数据哦\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }